import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {userSchema} from "../../validation/userSchema";

import {useDispatch, useSelector} from "react-redux";
import {getAuth} from "../../features/sliceReducer/authReducer";

import {KISAUser} from "../../models/KISAUser";

import {
  makeStyles,
  Box,
  Button,
  Paper,
  TextField,
  Typography,
  Checkbox,
  InputLabel,
} from "@material-ui/core";
import {RootState} from "../../features/store";
import {useEffect, useState} from "react";

const useStyle = makeStyles({
  root: {
    height: "100vh ",
    boxSizing: "border-box",
    padding: "80px 160px 0 160px",
  },
  signInHeader: {
    position: "relative",
    marginBottom: "20px",
    fontWeight: "bold",
    "&::before": {
      content: '""',
      position: "absolute",
      top: "110%",
      left: "50%",
      transform: "TranslateX(-50%)",
      width: "38px",
      height: "4px",
      backgroundColor: "red",
    },
  },
  logInBtn: {
    width: "180px",
    marginTop: "20px",
    borderRadius: "16px",
  },
  patent: {
    paddingTop: "20%",
  },
  patentTitle: {
    fontWeight: "bold",
    paddingBottom: "10px",
  },
  copyRight: {
    color: "#767c88",
  },
});

const SignUp = () => {
  const classes = useStyle();
  const dispatch = useDispatch();

  // const {autoLogin} = useSelector((state: RootState) => state.auth);

  const [isAutoLogin, setAutoLogin] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    getValues,
    reset,
    formState: {errors},
  } = useForm<KISAUser>({resolver: yupResolver(userSchema)});

  const onSubmit = handleSubmit(({loginID, loginPW}: KISAUser) => {
    dispatch(getAuth({loginID, loginPW}));
    // dispatch(getAuth2({ loginID, loginPW, callback : toggle2}));
  });

  let loginID = "";
  let loginPW = "";

  useEffect(() => {
    const loginStorage = localStorage.getItem("auto-login");
    if (loginStorage) {
      const loginInfo = JSON.parse(loginStorage.toString());
      console.log(loginInfo);
      if (loginInfo) {
        reset({loginID: loginInfo["loginId"], loginPW: loginInfo["password"]});
        loginID = loginInfo["loginId"];
        loginPW = loginInfo["password"];
        setAutoLogin(true);
      }
    }
  }, []);

  return (
    <form>
      <Paper className={classes.root}>
        <Box px={2} py={3}>
          <Typography variant="h5" align="center" className={classes.signInHeader}>
            Sign In
          </Typography>
          <Controller
            name="loginID"
            control={control}
            defaultValue={loginID}
            render={({field}) => (
              <TextField
                {...field}
                label="로그인 아이디"
                placeholder="Enter userID..."
                required
                fullWidth
                // variant="outlined"
                margin="normal"
                error={errors.loginID ? true : false}
              />
            )}
          />
          <Typography variant="inherit" color="textSecondary">
            {errors.loginID?.message}
          </Typography>
          <Controller
            name="loginPW"
            control={control}
            defaultValue={loginPW}
            render={({field}) => (
              <TextField
                {...field}
                type="password"
                label="비밀번호"
                placeholder="Enter Password..."
                required
                // variant="outlined"
                fullWidth
                margin="normal"
                error={errors.loginPW ? true : false}
              />
            )}
          />
          <Typography variant="inherit" color="textSecondary">
            {errors.loginPW?.message}
          </Typography>
          <Box display="flex" alignItems="center">
            <Checkbox
              id="autoLogin"
              checked={isAutoLogin}
              onChange={() => setAutoLogin(!isAutoLogin)}
            />
            <InputLabel htmlFor="autoLogin">ID/PW 저장</InputLabel>
          </Box>

          <Box mt={3}>
            <Button
              type="button"
              variant="contained"
              color="primary"
              className={classes.logInBtn}
              onClick={() => {
                if (isAutoLogin) {
                  const loginInfo = {loginId: getValues("loginID"), password: getValues("loginPW")};
                  localStorage.setItem("auto-login", JSON.stringify(loginInfo));
                } else {
                  localStorage.removeItem("auto-login");
                }
                onSubmit();
              }}
            >
              Log In
            </Button>
          </Box>
        </Box>
        <Box className={classes.patent}>
          <Typography variant="subtitle1" className={classes.patentTitle}>
            특허 제10-2726726호{" "}
          </Typography>
          <Typography variant="body2" className={classes.copyRight}>
            COPYRIGHT (C) 2024 KOREA INDUSTRIAL SAFETY ASSOCIATION.
            <br /> ALL RIGHTS RESERVED
          </Typography>
        </Box>
      </Paper>
    </form>
  );
};

export default SignUp;
